import React from 'react';
import Icon from "../icon/Icon";
import {footer} from "../../../../constants/copyright";
import {safeHTML} from "../../../../utils/safeHTML";
import Picture from "../picture/Picture";
import SocialBlock from "../../../socialBlock/SocialBlock";
import FooterApp from "./FooterApp";
import AppearSensor from "../../helpers/appearSensor/AppearSensor";
import classNames from "classnames";
import Breadcrumbs from "../../../breadcrumbs/Breadcrumbs";
import styles from "./Footer.module.scss";


export default function Footer() {
  const {
    logo,
    text,
    partner,
    app,
    socialBlock
  } = footer;

  const partnerInfo = () => (
   <div className={styles.footer__partner}>
     <div className={styles.footer__partnerLogo}>
       <Picture {...partner?.image}/>
     </div>
     <div className={styles.footer__partnerText}>{safeHTML(partner?.text)}</div>
   </div>
  );

  return (
    <footer className={styles.footer}>
      <AppearSensor partialVisibility={true}>
        {({hasBeenVisible})=>(
          <div className={classNames(styles.footer__content,{
            [styles.footer__content_show]:hasBeenVisible
          })}>
            <Breadcrumbs/>
            <a className={styles.footer__logo} {...logo.attr}>
              <Icon name={logo.icon} width={160} height={32} />
            </a>
            <div className={styles.footer__text}>{safeHTML(text)}</div>
            {partnerInfo()}
            <div className={styles.footer__social}>
              <SocialBlock {...socialBlock}/>
            </div>
            <FooterApp {...app}/>

            <div className={styles.footer__copyright}>{safeHTML("© 2026 АО «Технологическая Компания «Центр»")}</div>
          </div>
        )}
      </AppearSensor>

    </footer>

  )
}
